<template>
    <div class="ds-exchange-card">

        <div class="flex justify-between">
            <div class="ds-exchange-card-title mb-3 cursor-pointer" @click="emit('user')">
                {{ position }}
            </div>
            <div class="flex ds-exchange-card-status">
                <icon v-if="isFire" class="text-darkred mr-2 max-h">
                    <IconFire />
                </icon>
                <VacancyStatus :status />
            </div>
        </div>

        <div class="ds-exchange-card-body">
        <div class="ds-exchange-card-date mb-2"><span class="pr-3">{{ date }}</span> {{ startTime }} - {{ endTime }}</div>
        <div class="ds-exchange-card-text ds-exchange-card-clamp mb-4">
            {{ department }}
        </div>

            <div v-if="salary" class="ds-exchange-card-muted ds-exchange-card-clamp mb-4">Ставка: {{ salary }} руб. в час</div>
            <Skills v-if="skills.length" :skills />
            <div v-if="comment" class="ds-exchange-card-muted ds-exchange-card-clamp mb-4">Комментарий: {{ comment }}
            </div>
        </div>

        <div class="ds-exchange-card-footer">
            <div v-if="assigned">
                <User :first-name="assigned.first_name" :last-name="assigned.last_name" :avatar="assigned.avatar" :subtitle="assigned.position?.name" exchange />
            </div>
            <div v-else-if="!responded.length" class="ds-exchange-card-text">Нет откликов</div>
            <div v-else-if="responded.length === 1" class="flex group">
                <VacancyRespondedUser :user="responded[0]" :vacancy-id="vacancy.id" />
                <Tooltip class="w-64 text-gray left-0 top-10 text-sm">
                    <div class="mb-1">{{ responded[0].position.name }}</div>
                    <div class="mb-1">{{ responded[0].department.name }}</div>
                    <div class="mb-1">{{ responded[0].department.address }}</div>
                </Tooltip>
            </div>
            <div v-else @click="openRespondedList" class="ds-exchange-card-action ds-exchange-assign-button"><span class="ds-exchange-assign-plus">+</span>Есть отклики ({{
                responded.length }})</div>
            <VacancyRespondedList class="absolute" :list="responded" :vacancy-id="vacancy.id" v-if="showRespondedList"
                v-click-outside="closeRespondedList" />
        </div>
    </div>
</template>

<script setup lang="ts">
interface Props {
    vacancy: any,

}
import { computed, ref } from 'vue'
import dayjs from 'dayjs'
import User from '../User.vue';
import VacancyRespondedList from './VacancyRespondedList.vue';
import VacancyStatus from './VacancyStatus.vue';
import VacancyRespondedUser from './VacancyRespondedUser.vue';
import Skills from './Skills.vue';
import { useScheduleStore } from '@/stores/scheduleStore';
import IconFire from '@/ui/icons/IconFire.vue';
import Tooltip from './Tooltip.vue';

const { vacancy } = defineProps<Props>()
const emit = defineEmits(['user'])
const store = useScheduleStore()
const showRespondedList = ref(false)

const date = computed(() => dayjs(vacancy.dttm_work_start_at).format('DD.MM.YYYY'))
const startTime = computed(() => dayjs(vacancy.dttm_work_start_at).format('HH:mm'))
const endTime = computed(() => dayjs(vacancy.dttm_work_end_at).format('HH:mm'))
const position = computed(() => vacancy.position.name)
const department = computed(() => vacancy.department.name)
const responded = computed(() => vacancy.responded_users)
const assigned = computed(() => vacancy.assigned_user)
const comment = computed(() => vacancy.comment)
const status = computed(() => vacancy.status)
const skills = computed(() => store.positions.find(item => item.name === position.value)?.skills || [])
const salary = computed(() => vacancy.salary_hour)
const isFire = computed(() => {
    const now = dayjs();
    const targetTime = dayjs(vacancy.dttm_work_start_at);
    const diffInSeconds = targetTime.diff(now, 'second');
    // Проверяем: время в будущем И разница меньше 24 часов (86 400 секунд)
    return diffInSeconds > 0 && diffInSeconds < 86400;
})

const openRespondedList = () => {
    showRespondedList.value = true
}

const closeRespondedList = () => {
    showRespondedList.value = false
}

</script>
